import { Text as ChakraText } from "@chakra-ui/react";
import styles from "./Text.module.css";

const Text = ({ content }) => {
  return (
    <ChakraText
      as="div"
      fontSize="lg"
      className={styles.content}
      dangerouslySetInnerHTML={{ __html: content }}
    ></ChakraText>
  );
};

export default Text;
